import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Client = () => {
  const [avantages, setAvantages] = useState([]);
  const Url = process.env.REACT_APP_URL_DEV;

  useEffect(() => {
    axios
      .get(`${Url}/api/Avantage/all`)
      .then((response) => {
        setAvantages(response.data.data);
      })
      .catch((error) => {
        console.error('Erreur lors du chargement des avantages:', error);
      });
  }, []);

  return (
    <div className="client-area pd-bottom-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-12 text-center">
            <h3>
              {avantages.length > 0
                ? avantages[0].AvantageTitre
                : 'Nos avantages'}
            </h3>
          </div>

          <div className="row fix">
            {avantages.map((item, index) => (
              <div key={index} className="item col-lg-3 col-md-6 col-sm-12">
                <img
                  style={{ width: '40%' }}
                  src={`${Url}/images/${item.AvantageIcone}`}
                  alt={item.SousTitre}
                />
                <h4>{item.SousTitre}</h4>
                <p className="px-3 text-justify">{item.AvantageDescription}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Client;
